import { HelpBlurbDataStore } from 'sharebase/dataStores/help-blurb-datastore';
import { 
	CommonUtilsService, 
	StaticToggleService 
} from 'util/services';
import { InterfaceFor } from 'util/domain';
import { HelpBlurbFactory } from 'sharebase/factories/helpBlurbFactory';
import { HelpBlurb } from 'sharebase/domain';

require('./help-blurb.styles');
const template = require('./help-blurb.template');


export class HelpBlurbController implements ng.IComponentController {
	public static $inject = [
		'$timeout',
		'sbHelpBlurbFactory'
	];

	public blurb:HelpBlurb;
	public shouldShowBlurb:boolean = false;

	//From isolated scope of component
	private blurbText:string;
	private blurbId:string;

	constructor(
		$timeout:ng.ITimeoutService,
		sbHelpBlurbFactory:HelpBlurbFactory
	){
		this.blurb = sbHelpBlurbFactory.create(this.blurbText, this.blurbId);
		let showBlurb = !this.blurb.hasBeenViewed;
		
		//timeout to have blurb slide down
		if(showBlurb) {
			$timeout(() => { this.shouldShowBlurb = true; }, 200);
		}
	}

	public hideBlurb() {
		this.shouldShowBlurb = false;
		this.blurb.markAsViewed();
	}
}

class NullHelpBlurbController implements InterfaceFor<HelpBlurbController> {
	public blurb:HelpBlurb;
	public shouldShowBlurb:boolean = false;
	public hideBlurb = angular.noop;
}

export function HelpBlurbDirective(
	staticToggleService:StaticToggleService
) {
	if(staticToggleService.isEnabled('help-blurbs')) {
		return {
			restrict: 'E',
			controller: HelpBlurbController,
			controllerAs: 'vm',
			template,
			bindToController: {
				blurbText: '@',
				blurbId: '@'
			},
			scope: {}
		};
	}
	else {
		return {
			restrict: 'E',
			controller: NullHelpBlurbController,
			controllerAs: 'vm',
			template,
			bindToController: {
				deploymentId: '@',
			},
			scope: {}
		};
	}
}

HelpBlurbDirective.$inject =  [
	'staticToggleService'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/help-blurb/help-blurb.component.ts